import { i18n, defaultNS, flattenResources } from "@whatslly/commons/i18nService";

i18n.addResources(
  "en",
  defaultNS,
  flattenResources({
    copy_to_clipboard: "Copy to clipboard",
  })
);
i18n.addResources(
  "es",
  defaultNS,
  flattenResources({
    copy_to_clipboard: "Copiar al portapapeles",
  })
);
i18n.addResources(
  "pt",
  defaultNS,
  flattenResources({
    copy_to_clipboard: "Copiar para a área de transferência",
  })
);

export default i18n;
